<template>
  <v-container class="m-auto account-main-div">
    <v-card>
      <div class="d-flex justify-content-center">
        <v-card
          elevation="4"
          rounded="xl"
          width="250px"
          tile
          :class="
            isActive
              ? 'border-primary accoun account-selection'
              : 'border-light account-selection'
          "
          class="card-selector text-center rounded-xl m-4"
          @click="onClickPersonalAccount('personal')"
        >
          <div class="p-4 h-100" style="position: relative">
            <h6
              :class="
                isActive
                  ? 'text-primary-color font-weight-bold'
                  : 'text-secondary font-weight-normal'
              "
            >
              {{ $t("personal") }}
            </h6>
            <br />
            <v-icon
              :color="isActive ? 'primary' : 'grey'"
              large
              class="account-icons"
              style="width: 90px; height: 85px; border-radius: 50%"
              :style="
                isActive
                  ? 'border: 1px solid #ff6b00;'
                  : 'border: 1px solid #6c757d;'
              "
            >
              mdi-account-tie
            </v-icon>
            <br />

            <v-icon
              v-show="isActive"
              color="primary"
              large
              class="float-right account-icons-check"
              style="position: absolute; bottom: 15px; right: 20px"
            >
              mdi-check-circle
            </v-icon>
          </div>
        </v-card>

        <v-card
          elevation="4"
          rounded="xl"
          width="250px"
          tile
          :class="
            isActiveBusiness
              ? 'border-primary accoun account-selection'
              : 'border-light account-selection'
          "
          class="card-selector rounded-xl text-center p-0 m-4"
          @click="onClickBusinessAccount('business')"
        >
          <div class="p-4 h-100" style="position: relative">
            <h6
              :class="
                isActiveBusiness
                  ? 'text-primary-color font-weight-bold'
                  : 'text-secondary font-weight-normal'
              "
            >
              {{ $t("business") }}
            </h6>
            <br />
            <v-icon
              :color="isActiveBusiness ? 'primary' : 'grey'"
              large
              class="account-icons"
              style="
                width: 90px;
                height: 85px;
                color: #b4b4b4;
                border-radius: 50%;
              "
              :style="
                isActiveBusiness
                  ? 'border: 1px solid #ff6b00;'
                  : 'border: 1px solid #6c757d;'
              "
            >
              mdi-briefcase-account
            </v-icon>
            <br />

            <v-icon
              v-show="isActiveBusiness"
              color="primary"
              large
              class="float-right account-icons-check"
              style="position: absolute; bottom: 15px; right: 20px"
            >
              mdi-check-circle
            </v-icon>
          </div>
        </v-card>
      </div>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="text-capitalize float-right"
          @click="onClickNext"
          color="primary"
        >
          {{ $t("next") }}
          <v-icon dark right> mdi-arrow-right </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Customer Main",
  data() {
    return {
      name: "",
      isActive: false,
      isActiveBusiness: false,
      loader: false,
      is_partner: false,
    };
  },
  props: {
    addProfilePayload: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  mounted() {
    const user_type = sessionStorage.getItem("user_type");
    // console.log("addProfilePayload: ", JSON.stringify(this.addProfilePayload))
    if (user_type == "BUS") {
      this.isActive = false;
      this.isActiveBusiness = true;
    } else {
      this.isActive = true;
      this.isActiveBusiness = false;
    }
  },
  methods: {
    onClickNext() {
      if (this.isActive && !this.isActiveBusiness) {
        this.$router.push("/IndCustomer");
      }
      if (!this.isActive && this.isActiveBusiness) {
        this.$router.push("/BusCustomer");
      }
    },
    onClickPersonalAccount() {
      this.isActive = true;
      this.isActiveBusiness = false;
      sessionStorage.setItem("user_type", "IND");
      this.addProfilePayload.user_type == "IND";
      this.$emit("onAccounSelect", "IND");
    },
    onClickBusinessAccount() {
      this.isActive = false;
      this.isActiveBusiness = true;
      sessionStorage.setItem("user_type", "BUS");
      this.addProfilePayload.user_type == "BUS";
      this.$emit("onAccounSelect", "BUS");
      // setTimeout(() => this.$router.push({ name: "BusUserInfo" }), 100);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.btn-light {
  font-weight: bold;
  color: $dimgrey;
  background: $white;
  margin: 0 10px;
  &:not(:disabled) {
    &:not(.disabled).active {
      color: $secondary;
    }
    &:not(.disabled) {
      &:active {
        color: $secondary;
      }
    }
  }
  &:hover {
    // color: #fa6706;
    background: $white;
  }
}
.selected_class {
  &:hover {
    // border: 1px solid rgb(255, 0, 43) !important;
    // background: $white;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    // width: %;
    background: #f8f9fa;
    border-radius: 7px;
  }
}
button.btn.px-5.py-3.btn-light.btn-lg.individual-select {
  border: 1px solid rgb(255, 0, 43) !important;
  // color: #ff6b00;
  background: #fff;
}
button.btn.px-5.py-3.btn-light.btn-lg.business-select {
  border: 1px solid red !important;
  // color: #ff6b00;
  background: #fff;
}
.border-primary {
  border: 1px solid $primary;
}
</style>
